import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Grid } from "@material-ui/core";
import { MENU_RECETAS } from "../../utils/constants";
import { RecetasDigitalesBreadCrumb } from "./UI/RecetasDigitalesBreadCrumb";
import { RecetasDigitalesIngresoHome } from "./Ingreso/RecetasDigitalesIngresoHome";
import { GestionHistorialRecetasHome } from "./gestionRecetas/GestionHistorialRecetasHome";
import { AUTORIZACIONES_PERMISOS } from "../../utils/permisos";
import { validarSoloUnPermiso } from "../../helpers/permisos";

const style = {
  root: {
    flexGrow: 1,
  },
};

export const RecetasDigitalesHome = (props) => {

  const dispatch = useDispatch();
  const { permisos: permisosUser } = useSelector((state) => state.auth);

  const [activeBreadcrumb, setActiveBreadcrumb] = useState();
  const [soloVisibleIngresoInterDom, setSoloVisibleIngresoInterDom] = useState(false);

  const resetRouteStateAndSetActiveBreacDrumb = (item) => {
    props.location.state = { from: props.location.pathname };
    setActiveBreadcrumb(item)
  }

  useEffect(() => {
    if (props.location.state?.from !== "/recetasDigitales/gestion") {
      
      if (props.location.state?.sendGestion)
        setActiveBreadcrumb(MENU_RECETAS.GESTION_HISTORIAL);
    } else {
      setActiveBreadcrumb(MENU_RECETAS.INGRESO_RECETA);
    }
  }, [props.location.state?.from, props.location.state?.fromHomeScreen, dispatch]);

  useEffect(() => {
    setSoloVisibleIngresoInterDom(validarSoloUnPermiso(permisosUser,
      AUTORIZACIONES_PERMISOS.INGRESO_INTERNACION_DOMICILIARIA
    ));
  }, [permisosUser]);

  return (
    <div className={style.root}>
      <Grid
        container
        spacing={1}
        direction="row"
        justify="center"
        alignItems="center"
      >
        <Grid item xs={12} styles={{ padding: 5 }}>
          <RecetasDigitalesBreadCrumb
            setActiveBreadcrumb={resetRouteStateAndSetActiveBreacDrumb}
            validarSoloUnPermiso={validarSoloUnPermiso}
            activeBreadcrumb={activeBreadcrumb}
            permisosUser={permisosUser}
          />
        </Grid>
        {activeBreadcrumb === MENU_RECETAS.INGRESO_RECETA && (
          <RecetasDigitalesIngresoHome
            soloVisibleIngresoInterDom={soloVisibleIngresoInterDom}
            fromGestion={
              props.location.state?.from === "/recetasDigitales/gestion"
                ? true
                : false
            }
          />
        )}
        {activeBreadcrumb === MENU_RECETAS.GESTION_HISTORIAL && (
          <GestionHistorialRecetasHome
            soloVisibleIngresoInterDom={soloVisibleIngresoInterDom}
            {...props}
          />
        )}
      </Grid>
    </div>
  );
};
